import React, { useState, useEffect, useRef } from 'react';
import { Clock } from 'lucide-react';
import { ENCORE_TIMER_SECONDS } from '@/utils/gameState';

interface TimerProps {
  isActive: boolean;
  onTimeout: () => void;
  className?: string;
  style?: React.CSSProperties; // Add style prop
}

const Timer: React.FC<TimerProps> = ({ isActive, onTimeout, className = '', style }) => {
  const [seconds, setSeconds] = useState(ENCORE_TIMER_SECONDS);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (isActive) {
      setSeconds(ENCORE_TIMER_SECONDS);
      timerRef.current = window.setInterval(() => {
        setSeconds(prev => prev - 1);
      }, 1000);
    }
    return () => {
      if (timerRef.current !== null) {
        clearInterval(timerRef.current);
      }
    };
  }, [isActive]);

  useEffect(() => {
    if (isActive && seconds <= 0) {
      if (timerRef.current !== null) {
        clearInterval(timerRef.current);
      }
      onTimeout();
    }
  }, [seconds, isActive, onTimeout]);

  // Don't render the timer if it's not active
  if (!isActive) return null;

  // Apply warning classes when time is running low
  const getTimerClass = () => {
    if (seconds <= 5) return 'text-red-500 animate-pulse';
    if (seconds <= 10) return 'text-yellow-500';
    return '';
  };

  return (
    <div 
      className={`flex items-center gap-1 font-bold text-sm ${getTimerClass()} ${className}`}
      style={style}
    >
      <Clock size={14} className='max-sm:hidden'/>
      {seconds}s
    </div>
  );
};

export default Timer;
